// src/app/const/routes.ts
export const ROUTES_PATHS = {
	LOGIN: '',
	MDP_RAPPEL: 'mdp-rappel',
	MON_COMPTE: 'mon-compte',
	AGENTS: 'agents',
	AGENCES: 'agences',
	ESTIMATIONS: 'estimations',
	CLIENTS: 'clients',
	TUTORIELS: 'tutoriels',
	MDP_REINIT: 'mdp-reinit',
	WELCOME: 'welcome',
	CHOIX_RENOV: 'choix-renov',
	CHOIX_RENOV_BIS: 'choix-renov-bis',
	BATIMENT: 'batiment',
	PIECES: 'pieces',
	ESTIMATION_RAPIDE: 'estimation-rapide',
	PIECE_PAR_PIECE: 'piece-par-piece',
	SIDEBAR_RECAP: 'sidebar-recap',
	PRODUITS: 'produits',
	INSCRIPTION: 'inscription',
	TRANSACTION: 'transaction',
	PARTENAIRES: 'partenaires',
	SIGN_ON: 'sign-on',
	ALL_USERS: 'all-users',
	CONTACT_EXTERNE: 'contact-externe'
};
